module.exports = __webpack_public_path__ + "static/media/platoLogo.fd5f11bf.png";